import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export type ConsultationDocumentsIconProps = SvgIconProps

export function ConsultationDocumentsIcon(props: ConsultationDocumentsIconProps) {
  const { htmlColor } = props
  return (
    <SvgIcon width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Consultation_documents">
        <g>
          <g id="XMLID_00000158714270442621311580000002067253436970030268_">
            <g>
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M162.402,63.301v34.21h-66.37v-25.86c-0.33-3.3-1.67-9.28-7.24-12.85
					c-1.5-0.97-3.05-1.58-4.43-1.94c-3.01,2.19-6.23,3.34-9.38,3.34c-0.12,0-0.23,0-0.35,0c-3.2,0.07-6.54-1.07-9.67-3.38
					c0,0,0,0-0.02,0c-1.4,0.37-2.99,0.95-4.54,1.98c-2.73,1.73-4.44,4.06-5.52,6.37c-1.08,2.3-1.52,4.59-1.71,6.25v10.02v1.14
					h-12.64v-19.28v-52.44c0-0.48,0.39-0.86,0.87-0.86h120.14c0.48,0,0.86,0.38,0.86,0.86V63.301z M87.952,41.661
					c0.1-0.32,0.93-3.2-0.5-4.15c-0.21-0.15-0.47-0.23-0.74-0.28c0.33-0.9,1.2-3.7,0.27-6.9c-0.26-0.88-1.08-3.24-3.3-5.06
					c-3.08-2.53-7.06-2.56-8.63-2.57c-0.08,0-0.13,0-0.16,0c-0.07,0-0.13,0-0.2,0s-0.14,0-0.2,0c-0.03,0-0.09,0-0.16,0
					c-1.57,0.01-5.56,0.04-8.63,2.57c-2.22,1.82-3.04,4.18-3.3,5.06c-0.93,3.2-0.08,6,0.25,6.9c-0.27,0.05-0.51,0.14-0.73,0.28
					c-1.43,0.95-0.6,3.83-0.49,4.15c0.41,1.37,1.24,2.26,1.72,2.69c0.31,1.23,1.3,4.44,4.3,7.01c0.64,0.55,3.62,3.11,7.15,3.01
					c0.03,0,0.05,0,0.09,0c0.03,0,0.06,0,0.1,0c3.51,0.1,6.5-2.46,7.14-3.01c2.99-2.57,3.98-5.78,4.29-7.01
					C86.702,43.921,87.532,43.031,87.952,41.661z"
              />
              <circle style={{ fill: '#ED1C24' }} cx="101.472" cy="148.071" r="25.65" />
            </g>
            <g>
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M40.532,63.301h-11.46c-2.79,0-5.06,2.27-5.06,5.07v14.21"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M177.372,96.971v-28.61c0-2.79-2.27-5.06-5.06-5.06h-9.91"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M40.532,82.581v-19.28v-52.44c0-0.48,0.39-0.86,0.87-0.86h120.14c0.48,0,0.86,0.38,0.86,0.86v52.44v34.21"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M177.372,97.511h3.06c1.55,0,2.76,1.35,2.58,2.9l-10.06,87.28c-0.15,1.32-1.26,2.31-2.59,2.31H29.722
					c-1.35,0-2.46-1.01-2.59-2.35l-10.15-102.21c-0.16-1.53,1.05-2.86,2.59-2.86h4.44h16.52h12.64h11.51c0.62,0,1.21,0.22,1.68,0.62
					l16.25,13.7c0.48,0.39,1.07,0.61,1.68,0.61h11.74h66.37H177.372z"
              />

              <circle
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                cx="101.472"
                cy="148.071"
                r="25.65"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="115.062"
                y1="25.901"
                x2="150.892"
                y2="25.901"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="115.062"
                y1="43.701"
                x2="150.892"
                y2="43.701"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="115.062"
                y1="61.491"
                x2="150.892"
                y2="61.491"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="115.062"
                y1="79.291"
                x2="150.892"
                y2="79.291"
              />

              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					91.612,148.071 101.472,148.071 111.332,148.071 				"
              />

              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					101.472,157.931 101.472,148.071 101.472,138.211 				"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M53.172,81.441v-10.02c0.19-1.66,0.63-3.95,1.71-6.25c1.08-2.31,2.79-4.64,5.52-6.37c1.55-1.03,3.14-1.61,4.54-1.98
					c0.02,0,0.02,0,0.02,0c3.13,2.31,6.47,3.45,9.67,3.38c0.12,0,0.23,0,0.35,0c3.15,0,6.37-1.15,9.38-3.34
					c1.38,0.36,2.93,0.97,4.43,1.94c5.57,3.57,6.91,9.55,7.24,12.85"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="63.082"
                y1="81.161"
                x2="63.082"
                y2="73.411"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="86.382"
                y1="97.371"
                x2="86.382"
                y2="73.411"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M86.702,37.231c-0.64-2.12-1.72-4.35-3.62-5.07c-2.35-0.88-4.23,1-7.87,1.2c-0.17,0.01-0.35,0.01-0.52,0.02
					c-0.17-0.01-0.35-0.01-0.53-0.02c-3.63-0.2-5.51-2.08-7.87-1.2c-1.89,0.72-2.99,2.95-3.63,5.07c0,0.01,0,0.01,0,0.02
					c0-0.01,0-0.01-0.01-0.02c-0.33-0.9-1.18-3.7-0.25-6.9c0.26-0.88,1.08-3.24,3.3-5.06c3.07-2.53,7.06-2.56,8.63-2.57
					c0.07,0,0.13,0,0.16,0c0.06,0,0.13,0,0.2,0s0.13,0,0.2,0c0.03,0,0.08,0,0.16,0c1.57,0.01,5.55,0.04,8.63,2.57
					c2.22,1.82,3.04,4.18,3.3,5.06c0.93,3.2,0.06,6-0.27,6.9c-0.01,0.01-0.01,0.01-0.01,0.02
					C86.702,37.241,86.702,37.241,86.702,37.231z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                d="
					M86.702,37.231h0.01c0.27,0.05,0.53,0.13,0.74,0.28c1.43,0.95,0.6,3.83,0.5,4.15c-0.42,1.37-1.25,2.26-1.73,2.69
					c-0.31,1.23-1.3,4.44-4.29,7.01c-0.64,0.55-3.63,3.11-7.14,3.01c-0.04,0-0.07,0-0.1,0c-0.04,0-0.06,0-0.09,0
					c-3.53,0.1-6.51-2.46-7.15-3.01c-3-2.57-3.99-5.78-4.3-7.01c-0.48-0.43-1.31-1.32-1.72-2.69c-0.11-0.32-0.94-3.2,0.49-4.15
					c0.22-0.14,0.46-0.23,0.73-0.28h0.01"
              />

              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeMiterlimit: 10,
                }}
                points="
					96.032,97.641 96.032,97.511 96.032,71.651 				"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_1"></g>
    </SvgIcon>
  )
}

export default ConsultationDocumentsIcon
